export var REQUEST_SUCCESS_CODE = 0;